// extracted by mini-css-extract-plugin
export default {"link":"BrowserOutdateModal_link__v2HNI"};